import DraftQuantity from './DraftQuantity'
export default DraftQuantity
